// Funções puras de cálculo financeiro para as metas.

export const MONTH_NAMES_PT = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

export function calcGoalMonthsRemaining(remaining, monthlyContribution) {
  if (remaining <= 0) return 0;
  if (!monthlyContribution || monthlyContribution <= 0) return Infinity;
  return Math.ceil(remaining / monthlyContribution);
}

export function calcProjectedDate(months) {
  if (!isFinite(months)) return null;
  const now = new Date();
  const target = new Date(now.getFullYear(), now.getMonth() + months, 1);
  const years = Math.floor(months / 12);
  const remainderMonths = months % 12;
  return {
    months,
    years,
    remainderMonths,
    monthName: MONTH_NAMES_PT[target.getMonth()],
    year: target.getFullYear(),
  };
}

// Valor futuro de um aporte mensal (pagamento no fim do período) + principal.
export function calcCompoundInterest(principal, monthlyContribution, annualRate, years) {
  const r = annualRate / 100 / 12;
  const n = years * 12;
  if (r === 0) {
    return principal + monthlyContribution * n;
  }
  return (
    principal * Math.pow(1 + r, n) +
    monthlyContribution * ((Math.pow(1 + r, n) - 1) / r)
  );
}

// Quanto guardar por mês para acumular `target` em exatamente `months` meses,
// partindo de `principal` com taxa anual `annualRate` (%).
export function calcRequiredMonthlyContribution(target, principal, months, annualRate) {
  if (months <= 0) return Infinity;
  if (principal >= target) return 0;
  const r = annualRate / 100 / 12;
  if (r === 0) return (target - principal) / months;
  const factor = Math.pow(1 + r, months);
  const pmt = (target - principal * factor) * r / (factor - 1);
  return pmt > 0 ? pmt : Infinity;
}

// Quantos meses até acumular `target` partindo de `principal`, poupando
// `monthlyContribution` por mês com taxa anual `annualRate` (%).
// Retorna Infinity se nunca alcançar.
export function calcMonthsToReachTarget(target, principal, monthlyContribution, annualRate) {
  if (principal >= target) return 0;
  if (!monthlyContribution || monthlyContribution <= 0) return Infinity;

  const r = annualRate / 100 / 12;
  const needed = target - principal;

  if (r === 0) {
    return Math.ceil(needed / monthlyContribution);
  }

  // FV = P*(1+r)^n + C * ((1+r)^n - 1)/r = target
  // => (1+r)^n = (target*r + C) / (P*r + C)
  const numerator = target * r + monthlyContribution;
  const denominator = principal * r + monthlyContribution;
  if (denominator <= 0 || numerator / denominator <= 0) return Infinity;

  const n = Math.log(numerator / denominator) / Math.log(1 + r);
  if (!isFinite(n) || n < 0) return Infinity;
  return Math.ceil(n);
}
